import React, { useCallback, useRef, useState } from 'react';
import { Textinput, Button, Flex, theme } from '../../../ui';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { TOAST_ERROR } from '../../../utils/constants';
import { enqueueSnackbar } from 'notistack';
import Buttons from '../../../ui/Buttons';
import { useRequestNewPassword } from '../hooks';

const SuccessMsg = styled.div`
  padding: 10px;
  border-radius: 5px;
  box-shadow:0 0 15px 0 ${theme.colors.NEU_200};
  background-color: ${theme.colors.SUCCESS_LIGHT};
`

const ForgotPassword = ({ onCancel }) => {
  const { t } = useTranslation();
  const emailRef = useRef(null);
  const requestNewPassword = useRequestNewPassword();
  const [sent, setSent] = useState(false);

  const handleReset = useCallback(() => {
    const value = emailRef.current.value
    if (!value) return enqueueSnackbar(t('auth.noEmail'), { variant: TOAST_ERROR })
    requestNewPassword({ email: value }).then((res) => {
      if (res && 'data' in res) {
        emailRef.current.value = '';
        setSent(true);
      }
    });
  }, [requestNewPassword, t]);

  return (
    <Flex direction='column' gap='30'>
      <Textinput
        autoFocus
        margin='dense'
        id='email'
        label={t('globals.email')}
        type='email'
        fullWidth
        inputRef={emailRef}
      />
      {sent &&
        <SuccessMsg className="alert success-alert">{t('auth.forgotPassNextStepLabel')}</SuccessMsg>
      }
      <Flex gap='30'>
        <Buttons.Cancel onClick={onCancel} />
        <Button onClick={handleReset}>{t('auth.resetPassword')}</Button>
      </Flex>
    </Flex>
  );
};

export default ForgotPassword;
